import { AdditionalInsured } from "@covertree/agent-portal-graphql";

export const mapAdditionalInsuredName = (
  additionalInsured?: AdditionalInsured
) => {
  return additionalInsured?.adFirstName && additionalInsured?.adLastName
    ? `${additionalInsured.adFirstName} ${additionalInsured.adLastName}`
    : "N/A";
};
